import type {
  CatalogEntryResponse,
  CreateCatalogEntryRequest,
  UpdateCatalogEntryRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const councilsApi = {
  list(includeArchived = false) {
    return apiRequest<readonly CatalogEntryResponse[]>('/platform/councils', {
      query: { includeArchived },
    });
  },

  create(body: CreateCatalogEntryRequest) {
    return apiRequest<CatalogEntryResponse>('/platform/councils', { method: 'POST', body });
  },

  update(id: string, body: UpdateCatalogEntryRequest) {
    return apiRequest<CatalogEntryResponse>(`/platform/councils/${id}`, {
      method: 'PATCH',
      body,
    });
  },

  archive(id: string) {
    return apiRequest<{ archived: true }>(`/platform/councils/${id}/archive`, {
      method: 'POST',
    });
  },

  restore(id: string) {
    return apiRequest<{ restored: true }>(`/platform/councils/${id}/restore`, {
      method: 'POST',
    });
  },
};
